export default __webpack_public_path__ + "static/media/adjectiveVsAdverb.fe196d08.png";